import axios from 'axios'

import { get } from '@bigyouth/base'

import emitter from '../utils/emitter'

import { FORM_ACTIONS } from './formValidation'

export default {
  name: 'contact-form',

  options: {
    localesKey: 'contactForm',
    endpoint: 'https://statement.bigyouth.fr/api/mail',
    method: 'post',
  },

  subjects: [
    'showroom-appointment',
    'general-info',
    'order-product',
    'product-info',
    'order-info',
    'delivery',
    'exchange-return',
    'after-sales',
    'ring-sizer',
    'press',
    'other',
  ],
  productRefSubjects: ['product-info'],
  orderRefSubjects: ['order-info', 'delivery', 'exchange-return'],

  ui: {
    subjectSelect: '[js-contact-form-subject]',
    productRefWrapper: '[js-contact-form-product-ref]',
    orderRefWrapper: '[js-contact-form-order-ref]',
    'inputs[]': 'select, input, textarea',
    successLabel: '[js-contact-form-success]',
    errorLabel: '[js-contact-form-error]',
  },

  events: [
    {
      target: 'subjectSelect',
      on: 'change',
      handle: 'handleSubjectChange',
    },
  ],

  componentDidMount () {
    const urlParams = new URLSearchParams(window.location.search)
    const urlSubject = urlParams.get('subject')

    if (urlSubject && this.subjects.includes(urlSubject)) {
      this.ui.subjectSelect.value = urlSubject
      this.handleSubjectChange()
    }

    emitter.on(FORM_ACTIONS.SUBMIT, this.handleFormSubmit)
  },

  handleSubjectChange () {
    const selectedValue = this.ui.subjectSelect.value

    if (this.productRefSubjects.includes(selectedValue)) {
      this.showInputWrapper(this.ui.productRefWrapper)
      this.hideInputWrapper(this.ui.orderRefWrapper)
    } else if (this.orderRefSubjects.includes(selectedValue)) {
      this.showInputWrapper(this.ui.orderRefWrapper)
      this.hideInputWrapper(this.ui.productRefWrapper)
    } else {
      this.hideInputWrapper(this.ui.orderRefWrapper)
      this.hideInputWrapper(this.ui.productRefWrapper)
    }
  },

  handleFormSubmit (options) {
    if (this.props.formId === options.formId) {
      // Create an object containing all the inputs, with the names as keys.
      const data = this.ui.inputs.reduce((acc, { name, value }) => ({
        ...acc,
        [name]: value,
      }), {})

      axios({
        url: this.options.endpoint,
        method: this.options.method,
        data,
      })
        .then(this.handleFormSuccess.bind(this))
        .catch(this.handleFormError.bind(this))
    }
  },

  handleFormSuccess () {
    this.ui.successLabel.classList.remove('is-hidden')
    this.ui.errorLabel.classList.add('is-hidden')

    this.ui.inputs.forEach((input) => {
      input.value = ''

      if (input.tagName === 'SELECT') {
        input.selectedIndex = 0
        input.dispatchEvent(new Event('change'))
      }
    })
  },

  handleFormError () {
    this.ui.successLabel.classList.add('is-hidden')
    this.ui.errorLabel.classList.remove('is-hidden')
  },

  hideInputWrapper (target) {
    target.setAttribute('hidden', '')
    const targetInput = get('input', target)

    if (targetInput) {
      targetInput.removeAttribute('required')
      targetInput.removeAttribute('js-required-field')
    }
  },

  showInputWrapper (target) {
    target.removeAttribute('hidden')
    const targetInput = get('input', target)

    if (targetInput) {
      targetInput.setAttribute('required', '')
      targetInput.setAttribute('js-required-field', '')
    }
  },
}
